import { Component, type ReactNode } from 'react'
import { Box, Typography, Button } from '@mui/material'
import { DASHBOARD_ENDPOINT } from '../utils/Endpoints'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('Error caught in ErrorBoundary:', error, errorInfo)

    // Handle chunk loading errors specifically
    if (
      error instanceof TypeError &&
      error.message.includes('Failed to fetch')
    ) {
      console.warn('Chunk loading error detected. Consider reloading the page.')
    }
  }

  handleReload = () => {
    window.location.href = DASHBOARD_ENDPOINT
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display='flex'
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
          height='100vh'
          gap={2}
        >
          <Typography variant='h5' color='error'>
            Oops! Something went wrong.
          </Typography>
          <Typography variant='body2'>
            Please try refreshing the page or contact support.
          </Typography>
          <Box
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            gap={'30px'}
          ></Box>
          <Box
            component={Button}
            variant='contained'
            color='primary'
            onClick={this.handleReload}
            textTransform={'none'}
          >
            Reload
          </Box>
        </Box>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
